export const LPL_DELIVERING_FIRM_NAME = "LPL Financial";

export const DELIVERING_FIRMS = [
  "AMERIPRISE - AMERICAN ENTERPRISE INVESTMENT SERVICES INC.",
  "AXOS CLEARING LLC",
  "BANK OF AMERICA N.A.",
  "BANK OF AMERICA, N.A./LASALLE BANK N.A.",
  "BANK OF AMERICA, NATIONAL ASSOCIATION",
  "BANK OF AMERICA, N.A.",
  "BBVA SECURITIES INC.",
  "BMO BANK NATIONAL ASSOCIATION",
  "CHARLES SCHWAB & CO., INC.",
  "CIBC WORLD MARKETS CORP.",
  "CITADEL CLEARING LLC",
  "CITADEL SECURITIES LLC",
  "CITIGROUP PVT BANK/TRUST-DTC 2032",
  "CITIGROUP GLOBAL MARKETS INC.",
  "DEUTSCHE BANK SECURITIES INC.",
  "EDWARD D. JONES & CO.",
  "FIDELITY INVESTMENTS",
  "HSBC SECURITIES (USA) INC.",
  "HSBC BANK USA, NATIONAL ASSOCIATION",
  "JPMORGAN CHASE BANK, NATIONAL ASSOCIATION",
  "J.P. MORGAN SECURITIES LLC/JPMC",
  "J.P. MORGAN SECURITIES LLC",
  "JEFFERIES LLC",
  "LPL Financial",
  "MERRILL LYNCH, PIERCE, FENNER & SMITH INCORPORATED",
  "METROPOLITAN LIFE INSURANCE COMPANY",
  "MORGAN STANLEY & CO. LLC",
  "National Financial Service",
  "NORTHERN TRUST COMPANY/DTC",
  "OPPENHEIMER & CO. INC.",
  "PERSHING LLC",
  "RAYMOND JAMES & ASSOCIATES, INC.",
  "RAYMOND JAMES & ASSOCIATES, INC./RAYMOND JAMES TRUST COMPANY",
  "RBC CAPITAL MARKETS, LLC",
  "SEI PRIVATE TRUST COMPANY",
  "STIFEL, NICOLAUS & COMPANY, INCORPORATED",
  "T. ROWE PRICE INVESTMENT SERVICES, INC.",
  "UBS FINANCIAL SERVICES INC.",
  "UBS SECURITIES LLC",
  "THE VANGUARD GROUP, INC.",
  "VOYA INVESTMENTS DISTRIBUTOR, LLC",
  "WELLS FARGO SECURITIES, LLC",
  "WELLS FARGO CLEARING SERVICES, LLC",
  "WELLS FARGO BANK, NATIONAL ASSOCIATION",
];

export const deliveringFirmOptions = (currentValue) =>
  currentValue && !DELIVERING_FIRMS.includes(currentValue)
    ? [currentValue, ...DELIVERING_FIRMS]
    : DELIVERING_FIRMS;
